import React from "react";
import TableContainer from "./TableContainer";

//Import Breadcrumb

const Table = ({ header, data, onTableRowClick, checkedAll, setCheckedAll, pageSize, noHeader, headerTitleColor, headerBackground,
  sort, setSorted, sort_by, setSortBy }) => {
  return (
    <React.Fragment>
      <TableContainer
        columns={header || []}
        data={data || []}
        onTableRowClick={onTableRowClick}
        customPageSize={pageSize}
        checkedAll={checkedAll}
        setCheckedAll={setCheckedAll}
        sort={sort}
        headerTitleColor={headerTitleColor}
        headerBackground={headerBackground}
        setSorted={setSorted}
        sort_by={sort_by}
        setSortBy={setSortBy}
        noHeader={noHeader}
      />
    </React.Fragment>
  );
};

export default Table;
